import { Box, Typography } from '@mui/material';
import { DATAGRID_TABLE_CELL_WIDTH } from '../../../../utils/constants';
import { UNIT_SYSTEM } from '../../../../shared/config/hydraulics_constants';

const columns = (renderActions, renderDrillFluidCell, renderValueCell, currentUnit, rolloverUnits) => [
  {
    field: 'fromFluidId',
    headerName: 'From',
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
    renderEditCell: renderDrillFluidCell,
    editable: false,
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'toFluidId',
    headerName: 'To',
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
    renderEditCell: renderDrillFluidCell,
    editable: true,
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'pumps_output',
    headerName: `Pumps Output (${rolloverUnits?.pumps_output?.label})`,
    renderHeader: () => (
      <Box>
      <Typography sx={{ fontSize: '1.2rem' }}>
        Pumps Output
      </Typography>
      <Typography sx={{ fontSize: '1.2rem' }}>
        ({rolloverUnits?.pumps_output?.label})
      </Typography>
      </Box>
    ),
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH + 40,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
    renderEditCell: renderValueCell,
    editable: true,
    headerAlign: 'center',
    align: 'center',
    valueGetter: (params) => {
      if (params.value === null || params.value === undefined || params.value === '') {
        return '';
      }
      const value = Number(params.value);
      if (isNaN(value)) {
        return params.value;
      }
      return currentUnit !== UNIT_SYSTEM.US ? value : parseFloat(value.toFixed(rolloverUnits?.pumps_output.decimals));
    },
  },
  {
    field: 'pumps_spm',
    headerName: `Total SPM (${rolloverUnits?.pumps_spm?.label})`,
    renderHeader: () => (
      <Box>
      <Typography sx={{ fontSize: '1.2rem' }}>
        Total SPM
      </Typography>
      <Typography sx={{ fontSize: '1.2rem' }}>
        ({'spm'})
      </Typography>
      </Box>
    ),
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH + 40,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
    renderEditCell: renderValueCell,
    editable: true,
    headerAlign: 'center',
    align: 'center',
    valueGetter: (params) => {
      if (params.value === null || params.value === undefined || params.value === '') {
        return '';
      }
      const value = Number(params.value);
      if (isNaN(value)) {
        return params.value;
      }
      return currentUnit !== UNIT_SYSTEM.US ? value : parseFloat(value.toFixed(rolloverUnits?.pumps_spm.decimals));
    },
  },
  {
    field: 'actions',
    headerName: 'Actions',
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH - 90,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH - 90,
    headerAlign: 'center',
    align: 'center',
    renderCell: renderActions,
  }
];
export default columns;
